import { PolarisIcon, TaskAction } from '@tmt-insights/oms_fe_core/columns';
import { OrderJobTask } from '@/redux/slices/slice_types';
import styled from '@emotion/styled';
import { Button, Tooltip } from '@mui/material';
import { MouseEventHandler } from 'react';
import { useHistory } from 'react-router-dom';

type OptionalHistory = ReturnType<typeof useHistory> | undefined;

const TaskActionButton = ({ row, showPlayButton }: { row: OrderJobTask; showPlayButton?: boolean }) => {
  const nRow = structuredClone(row);
  const history = useHistory() as OptionalHistory;
  if (nRow.task_action?.actions?.find((a) => a.type === 'task_player')) {
    nRow.task_action!.actions = nRow.task_action?.actions?.filter((a) => a.type !== 'task_player');
    const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
      e.stopPropagation();
      e.preventDefault();

      const playerUrl = `/tasks/player/${nRow.id}`;
      if (history?.push) {
        history.push(playerUrl);
      } else {
        window.location.assign(playerUrl);
      }
    };
    return (
      <ActionContainer>
        <TaskAction task={nRow} />
        {showPlayButton && (
          <Tooltip title="Launch Player">
            <OutlinedButton variant="outlined" color="primary" onClick={handleClick}>
              <PolarisIcon icon="play" />
            </OutlinedButton>
          </Tooltip>
        )}
      </ActionContainer>
    );
  }
  return <TaskAction task={nRow} />;
};

export default TaskActionButton;

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  & [class$='ActionWrapper'] {
    width: auto;
  }
`;

const OutlinedButton = styled(Button)`
  border: 1px solid;
  border-color: ${({ theme }) => theme.palette.primary.main};
  border-radius: 50%;
  min-width: ${({ theme }) => theme.spacing(3)};
  min-height: ${({ theme }) => theme.spacing(3)};
  padding: 0;
  margin: 0;
`;
